(() => {
  const i18n = window.MESKAYA_I18N || {};

  /* Menu mobile */
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  /* Ajout au panier sans rechargement — cartes produit */
  document.querySelectorAll('.pcard__add form, .quick-add').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button) return;
      const old = button.textContent;
      button.disabled = true;
      button.textContent = i18n.adding || 'Ajout…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) throw new Error('cart');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        button.textContent = i18n.added || 'Ajouté ✓';
      } catch (_) {
        button.textContent = i18n.retry || 'Réessayer';
      }
      setTimeout(() => { button.disabled = false; button.textContent = old; }, 1400);
    });
  });

  /* Checkout direct de secours — visible même sans portefeuille accéléré */
  document.querySelectorAll('[data-express-checkout]').forEach((button) => {
    const form = button.closest('form');
    const accelerated = form && form.querySelector('.product-accelerated-checkout');
    const hasWallet = () => accelerated && accelerated.querySelector('shopify-accelerated-checkout, shopify-payment-button, button, a');

    const syncVisibility = () => {
      button.hidden = Boolean(hasWallet());
    };
    syncVisibility();
    if (accelerated) new MutationObserver(syncVisibility).observe(accelerated, { childList: true, subtree: true });

    button.addEventListener('click', async () => {
      if (!form) return;
      const old = button.textContent;
      button.disabled = true;
      button.textContent = i18n.buying || (document.documentElement.lang === 'ar' ? 'جاري التحويل…' : 'Ouverture…');
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) throw new Error('cart');
        window.location.href = window.Shopify.routes.root + 'checkout';
      } catch (_) {
        button.disabled = false;
        button.textContent = i18n.retry || 'Réessayer';
        setTimeout(() => { button.textContent = old; }, 1800);
      }
    });
  });

  /* Rail des étapes : molette horizontale au trackpad, sans capturer le scroll vertical */
  document.querySelectorAll('.steps__rail').forEach((rail) => {
    rail.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if (rail.scrollWidth <= rail.clientWidth) return;
    }, { passive: true });
  });

  /* Galerie produit : la vignette pilote l’image principale sans rechargement */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-product-main-image]');
    const index = gallery.querySelector('.product-gallery__index b');
    const thumbs = [...gallery.querySelectorAll('[data-product-thumbnail]')];
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.imageSrc;
        main.srcset = thumb.dataset.imageSrcset || '';
        main.alt = thumb.dataset.imageAlt || '';
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (index) index.textContent = String(thumbIndex + 1).padStart(2, '0');
      });
    });
  });

  /* Sélecteur d’offre et quantité */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const price = document.querySelector('[data-product-price]');
    const compare = document.querySelector('[data-product-compare]');
    const saving = document.querySelector('[data-product-saving]');

    form.querySelectorAll('[data-variant-option]').forEach((option) => {
      option.addEventListener('change', () => {
        form.querySelectorAll('.product-offer-card').forEach((card) => {
          card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked')));
        });
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (saving) {
          saving.textContent = option.dataset.saving ? (document.documentElement.lang === 'ar' ? 'توفير ' : 'Économie ') + option.dataset.saving : '';
          saving.hidden = !option.dataset.saving;
        }
      });
    });

    form.querySelectorAll('[data-quantity-stepper]').forEach((stepper) => {
      const input = stepper.querySelector('input[type="number"]');
      if (!input) return;
      const set = (value) => { input.value = Math.max(1, Number(value) || 1); };
      stepper.querySelector('[data-quantity-minus]')?.addEventListener('click', () => set(Number(input.value) - 1));
      stepper.querySelector('[data-quantity-plus]')?.addEventListener('click', () => set(Number(input.value) + 1));
      input.addEventListener('change', () => set(input.value));
    });
  });
})();
